import MuiTypography from '@mui/material/Typography';

const Typography = ({ variant, className = '', ...props }) => <MuiTypography variant={variant} className={className} {...props} />;

export default Typography;
